import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';


import { Perfil } from '../models/perfil';
import { ResponseBase } from '../models/response-base';
import { LocalStoreKeys } from '../shared/helpers/localstorage/local-store';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PerfilService {

    API: string = environment.API + 'Portal/perfis';

    constructor(private http: HttpClient) {
        this.currentPerfisSubject = new BehaviorSubject<Perfil[]>(JSON.parse(localStorage.getItem(LocalStoreKeys.perfis)));
        this.currentPerfis = this.currentPerfisSubject.asObservable();
    }

    private currentPerfisSubject: BehaviorSubject<Perfil[]>;
    public currentPerfis: Observable<Perfil[]>;

    public get currentPerfisValue(): Perfil[] {
        return this.currentPerfisSubject.value;
    }

    setCurrentPerfisValue(newPerfis: Perfil[]) {
        localStorage.setItem(LocalStoreKeys.currentUser, JSON.stringify(newPerfis));
        this.currentPerfisSubject.next(newPerfis);
    }

    getAll(gestorId: string, cedenteId: string): Observable<ResponseBase<Perfil[]>> {
        return this.http.get<ResponseBase<Perfil[]>>(`${this.API}/gestores/${gestorId}/cedentes/${cedenteId}`)
            .pipe(map(
                response => {
                    localStorage.setItem(LocalStoreKeys.perfis, JSON.stringify(response.result));
                    this.currentPerfisSubject.next(response.result);
                    return response;
                }
            ));
    }

    getAllPerfil(): Observable<ResponseBase<Perfil[]>> {
        return this.http.get<ResponseBase<Perfil[]>>(`${this.API}`);
    }
}
